import React from 'react';
import { Modal, CircleImage, Button } from 'olive-react-myoneui';
import { closeNotificationIcon, rightArrow, trashIcon } from '../../../../constants/icons';
import UserImage from './UserImage';

function NotificationModal({ show, toggleModal, item }) {
  return (
    <Modal show={show} onHide={toggleModal} centered className="notification-modal">
      <Modal.Header>
        <Button
          variant="icon"
          className="rounded-circle close-notifications"
          onClick={() => toggleModal(null)}
        >
          {closeNotificationIcon}
        </Button>
      </Modal.Header>
      <Modal.Body>
        <div className="notifications-block notifications-modal-detail">
          <CircleImage className="circle-wrap circle-wrap-lg bg-circle-primary text-white">
            <UserImage
              src={item?.sender?.profile_image}
              title={`${item?.sender?.first_name} ${item?.sender?.last_name}`}
            />
          </CircleImage>
          <div className="info-wrap">
            <div className="text-wrap">
              <h4>{item?.message}</h4>
            </div>
            <div className="time-wrap">
              <span>{new Date(item?.createdAt).toLocaleString()}</span>
              <div className="view-wrap">
                <div className="notification-delete" title="Remove">
                  {trashIcon}
                </div>
                <button className="text-primary cursor-pointer card-link">
                  View {rightArrow}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default NotificationModal;
